import type { ReactNode } from 'react';
import { cn } from '$lib/lib/cn';

type Tone = 'neutral' | 'positive' | 'warning' | 'danger' | 'info' | 'accent';

export interface BadgeProps {
  tone?: Tone;
  className?: string;
  children: ReactNode;
  'data-testid'?: string;
}

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-3 text-fg border-rule',
  positive: 'bg-positive/12 text-positive border-positive/30',
  warning: 'bg-warning/15 text-warning border-warning/35',
  danger: 'bg-danger/12 text-danger border-danger/30',
  info: 'bg-info/12 text-info border-info/30',
  accent: 'bg-accent/12 text-accent border-accent/30'
};

export function Badge({ tone = 'neutral', className, children, 'data-testid': testId }: BadgeProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex h-5 items-center gap-1 rounded-xs border px-1.5 text-2xs font-medium',
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
